var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('backlink'),_vm._v(" "),_c('h1',[_vm._v("Produits spéciaux")]),_vm._v(" "),_c('AdminTable',{attrs:{"config":_vm.config,"options":_vm.options,"items_provider":_vm.itemsProvider},scopedSlots:_vm._u([{key:"type",fn:function(ref){
var data = ref.data;
return [_vm._v("\n      "+_vm._s(_vm.$store.getters["product/getType"](data.value) ? _vm.$store.getters["product/getType"](data.value).text : data.value)+"\n    ")]}},{key:"parent_product_type",fn:function(ref){
var data = ref.data;
return [_vm._v("\n      "+_vm._s(_vm.$store.getters["product/getParentType"](data.value) ? _vm.$store.getters["product/getParentType"](data.value).text : "")+"\n    ")]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1a0aa7ba","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Product/ParentProductList.vue
// module id = 1089
// module chunks = 0